import { HttpClient } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { MatSelectModule } from "@angular/material/select";
import { GkComponentsModule, GkMapModule } from "@gk/gk-modules";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { SharedModule } from "../../shared/shared.module";
import { createTranslateLoader } from "../address-number-request-portal/address-number-request-portal.module";
import { TSFWDRNewRequestComponent } from "./new-request/new-request.component";
import { TSFWDRNewRequestFormService } from "./services/new-request-form/new-request-form.service";
import { TreesAndShrubsFellingWithDecisionRequestRoutingModule } from "./trees-and-shrubs-felling-with-decision-request-routing.module";
import { TreesAndShrubsFellingWithDecisionRequestComponent } from "./trees-and-shrubs-felling-with-decision-request.component";

@NgModule({
  declarations: [
    TreesAndShrubsFellingWithDecisionRequestComponent,
    TSFWDRNewRequestComponent,
  ],
  imports: [
    SharedModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    GkMapModule,
    GkComponentsModule,
    TreesAndShrubsFellingWithDecisionRequestRoutingModule,
    MatSelectModule,
  ],
  providers: [TSFWDRNewRequestFormService],
})
export class TreesAndShrubsFellingWithDecisionRequestModule {}
